import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpRequest } from '@angular/common/http';
import { LoggerService } from './logger.service';
import { AuthGaurdService } from './auth-gaurd.service';
import { Observable, throwError } from 'rxjs';
import { CommPlan } from '../models/commission/comm-plan.model';
import { environment } from '../../environments/environment';
import { CommPlanDetail } from '../models/commission/comm-plan-detail.model';
import { CustomHttpRespone } from '../models/customhttpresponse/custom-http-response';
import { AdjustmentsModel } from '../commission/adjustments/adjustments.model';
import { CalendarModel } from '../models/config/calendar.model';
import { KomFeed } from '../models/commission/kom-feed.model';
import { EntFeed } from '../models/commission/ent-feed.model';

import { FreeForm } from '../models/commission/free-form.model';
import { CallDetails } from '../models/commission/call-details.model';
import { DepndntKpi } from '../models/commission/depndnt-kpi.model';
import { DependentScoreKpiModel } from '../models/commission/dependentscore-kpi.model';
import { MobileFeedModel } from '../models/commission/mobile-feed.model';
import { EarningPotentialModel } from '../models/commission/earningpotential.model';
import { RntFeedModel } from '../models/commission/rnt-feed.model';

@Injectable({
  providedIn: 'root'
})
export class CommissionService {

  host: string = environment.apiUrl + 'commission';
  hostCal: string = environment.apiUrl + 'config/calendartype';

  tokenId: string = '';
  commModel = new CommPlan();
  kpiDetails: CommPlanDetail[] = [];
  salesChannels: string[] = [];
  commData: CommPlan[] = [];
  komFeedModel = new KomFeed();
  mobileFeedModel = new MobileFeedModel();
  rntFeedModel = new RntFeedModel();
  entFeedModel = new EntFeed();
  editKomFeedModel = new KomFeed();
  editEntFeedModel = new EntFeed();
  editMobileFeedModel = new MobileFeedModel();
  editRntFeedModel = new RntFeedModel();
  rntFeedResultsData: RntFeedModel[] = [];
  /** Server fetch chunk size (not the table "items per page"). */
  rntFeedChunkSize = 100;
  rntFeedTotalCount = 0;
  /** Chunk index (offset / chunkSize) → rows for that chunk. */
  rntFeedChunkCache: { [chunkIndex: number]: RntFeedModel[] } = {};
  loggedinUser: string = '';
  languages: string[];
  payrollCalender: string[];
  salesRepData: KomFeed[];
  callDetailModel = new CallDetails();

  constructor(private http: HttpClient, private logger: LoggerService, private authgurdService: AuthGaurdService, private authGaurdService: AuthGaurdService) {
    this.tokenId = this.authgurdService.getToken();

    this.loggedinUser = this.authGaurdService.loginUser();
    if (this.loggedinUser == "" || this.loggedinUser == null) {
      this.loggedinUser = "NA"
    } else {
      this.loggedinUser = this.authGaurdService.loginUser();
    }
  }

  public updateDpndntKpiDtls(depndntKpiDtls: DepndntKpi[]): Observable<CustomHttpRespone> {
    return this.http.post<CustomHttpRespone>(`${this.host}/updatedpndntKpitocommplan`, depndntKpiDtls);
  }

  public updateDpndntScoreKpiDtls(formData: FormData): Observable<CustomHttpRespone> {
    return this.http.post<CustomHttpRespone>(`${this.host}/updatedpndntscoreKpitocommplan`, formData);
  }

  public reInsertCommPlan(commPlanModel: CommPlan): Observable<CommPlan> {
    return this.http.post<CommPlan>(`${this.host}/addcommplan`, commPlanModel);
  }


  public getEarningPotentials(commPlanId: number, eDate: string): Observable<EarningPotentialModel[]> {
    return this.http.get<EarningPotentialModel[]>(`${this.host}/getearningpotentials` + '/' + commPlanId + '/' + eDate);
  }

  public getAllCommPlans(): Observable<CommPlan[]> {
    return this.http.get<CommPlan[]>(`${this.host}/allcommplanslist`);
  }
  public getCommPlanByAsOfDt(id: number): Observable<CommPlan> {
    return this.http.get<CommPlan>(`${this.host}/getcommplanbyasofdate` + '/' + id);
  }

  public getAsOfDate(comPlanId: number): Observable<CommPlan> {
    return this.http.get<CommPlan>(`${this.host}/getasofdate` + '/' + comPlanId);
  }

  public getDepndntKPI(kpiId: number, comp_plan_id: number, comm_plan_dtl_id: number, edate: string): Observable<DepndntKpi[]> {
    return this.http.get<DepndntKpi[]>(`${this.host}/getdpndntkpi` + '/' + kpiId + '/' + comp_plan_id + '/' + comm_plan_dtl_id + '/' + edate);
  }

  public getDepndntScoreKPI(kpiId: number, comp_plan_id: number, comm_plan_dtl_id: number, edate: string): Observable<DependentScoreKpiModel[]> {
    return this.http.get<DependentScoreKpiModel[]>(`${this.host}/getdependentscorekpi` + '/' + kpiId + '/' + comp_plan_id + '/' + comm_plan_dtl_id + '/' + edate);
  }

  public getMeasureAgainstDropdown(): Observable<CommPlanDetail[]> {
    return this.http.get<CommPlanDetail[]>(`${this.host}/getmeasureagainstlist`);
  }

  public deleteCommDetailValues(id: number): Observable<CustomHttpRespone> {
    let url = this.host + '/deletecomdetailvalues/' + id;
    return this.http.delete<CustomHttpRespone>(url);
  }

  public deleteCalvars(id: number): Observable<CustomHttpRespone> {
    let url = this.host + '/deletecalcvar/' + id;
    return this.http.delete<CustomHttpRespone>(url);
  }

  public getKpiDetailsForReplicatePlan(comPlanId: number, effDate: any): Observable<CommPlanDetail[]> {
    return this.http.get<CommPlanDetail[]>(`${this.host}/kpiplanslisttoreplicate` + '/' + comPlanId + '/' + effDate);
  }

  public getTierRangeValues(comPlanDtlId: number): Observable<CommPlanDetail[]> {
    return this.http.get<CommPlanDetail[]>(`${this.host}/tierrangevalues` + '/' + comPlanDtlId);
  }

  public getMeasureTypes(): Observable<any> {
    return this.http.get<any>(`${this.host}/measuretypelist`);
  }

  public getAdjust(commPeriod: number, salesChannel: string, commPlan: number): Observable<AdjustmentsModel[]> {
    return this.http.get<AdjustmentsModel[]>(`${this.host}/getAdjustMentList` + '/' + commPeriod + '/' + salesChannel + '/' + commPlan);
  }

  public validateEffictiveDt(commPlanId: number): Observable<CalendarModel[]> {
    return this.http.get<CalendarModel[]>(`${this.host}/getvalidatedt` + '/' + commPlanId);
  }

  public addAdjust(adjustmentsModel): Observable<CustomHttpRespone> {
    return this.http.post<CustomHttpRespone>(`${this.host}/addAdjustMent`, adjustmentsModel);
  }

  public getFreeFormSerchResults(searchWith: string): Observable<FreeForm[]> {
    return this.http.get<FreeForm[]>(`${this.host}/getfreeformresult/` + searchWith);
  }

  public uploadImages(file: File, id: any): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();
    formData.append('file', file);
    formData.append('id', id);
    formData.append('current_user', this.loggedinUser);

    const req = new HttpRequest('PUT', `${this.host}/uploadimages`, formData, {
      reportProgress: true,
      responseType: 'json'
    });
    return this.http.request(req);
  }

  public getSalesChannels(): Observable<any> {
    const url = 'http://localhost:9090/api/salescomm/commissionplan/findsaleschannel/this.tokenId';
    return this.http.get<any>(url);
  }

  public getHideCommPlans(salesChannel: string, hide: string): Observable<any> {
    const url = 'http://localhost:9090/api/salescomm/commissionplan/findsaleschannel/this.tokenId';
    return this.http.get<any>(url);
  }

  public createForm(dependentScoreKpiModel: DependentScoreKpiModel): FormData {
    const formData = new FormData();

    console.log(dependentScoreKpiModel.comp_plan_id);
    formData.append('id', dependentScoreKpiModel.id);
    formData.append('kpi_name', dependentScoreKpiModel.kpi_name);
    formData.append('kpi_weight', dependentScoreKpiModel.kpi_weight);
    formData.append('complex_kpi_id', dependentScoreKpiModel.complex_kpi_id);
    formData.append('comp_plan_id', dependentScoreKpiModel.comp_plan_id);
    formData.append('comm_plan_dtl_id', dependentScoreKpiModel.comm_plan_dtl_id);
    formData.append('kpi_id', dependentScoreKpiModel.kpi_id);
    formData.append('created_by', dependentScoreKpiModel.created_by);
    return formData;
  }

  public handleError(error: { error: { message: string; }; status: any; message: any; }) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }



  public getAllCommPlansByDate(): Observable<CommPlan[]> {
    return this.http.get<CommPlan[]>(`${this.host}/commplanslist`);
  }

  public replicateCommPlan(commPlanModel: CommPlan): Observable<CommPlan> {
    return this.http.post<CommPlan>(`${this.host}/replicatecommplan`, commPlanModel);
  }

  public getChargebackTypes(): Observable<CommPlanDetail[]> {
    return this.http.get<CommPlanDetail[]>(`${this.host}/getchargebacktypes`);
  }

  public getSalesChannelsList(): Observable<CommPlanDetail[]> {
    return this.http.get<CommPlanDetail[]>(`${this.host}/getsaleschannelslist`);
  }

  public getCalTypes(): Observable<CalendarModel[]> {
    return this.http.get<CalendarModel[]>(`${this.hostCal}/getcalendarlist`);
  }

  public updateCommPlanStatusToActive(Kpimaster: CommPlan[]): Observable<CommPlan> {
    return this.http.put<CommPlan>(`${this.host}/updateCommPlanStatusToActive`, Kpimaster);
  }

  public updateCommPlanStatusToInactive(Kpimaster: CommPlan[]): Observable<CommPlan> {
    return this.http.put<CommPlan>(`${this.host}/updateCommPlanStatusToInactive`, Kpimaster);
  }

  public getKpiDetailsForPlan(comPlanId: any, effDate: any): Observable<CommPlanDetail[]> {
    return this.http.get<CommPlanDetail[]>(`${this.host}/kpiplanslist` + '/' + comPlanId + '/' + effDate);
  }

  public getImage(comPlanId: any, effDate: any): Observable<CommPlanDetail[]> {
    return this.http.get<CommPlanDetail[]>(`${this.host}/getimage` + '/' + comPlanId + '/' + effDate);
  }

  public getAdminConfigData(): Observable<CommPlan[]> {
    return this.http.get<CommPlan[]>(`${this.host}/getadminconfiglist`);
  }

}